'use client';
import { LoadingBlockFullPage } from '@/components/loading/loading-block-full-page';
import { AppProviders } from '@/components/providers/app-providers';
import { ErrorBoundary } from '@/features/error-boundary/ErrorBoundary';
import { APP_ENV } from '@/lib/constants';
import '@/styles/globals.css';
import 'moment/locale/de';
import posthog from 'posthog-js';
import { Suspense, useEffect, type ReactElement, type ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export interface NextPageWithLayout {
    (): JSX.Element;
    getLayout?: (page: ReactElement) => ReactNode;
}

const MyApp = () => {
    const location = useLocation();

    useEffect(() => {
        if (APP_ENV === 'production') {
            const handleRouteChange = () => posthog?.capture('$pageview');
            handleRouteChange();
        }
    }, [location.pathname]);

    return (
        <ErrorBoundary>
            <AppProviders>
                <Suspense fallback={<LoadingBlockFullPage />}>
                    <Outlet />
                </Suspense>
            </AppProviders>
        </ErrorBoundary>
    );
};

export default MyApp;
